<template>
  <div style="overflow-y: scroll; overflow-x: hidden" class="wrapper">
    <div class="loading" v-if="showLoading">
      <a-spin size="large"></a-spin>
    </div>
  </div>
</template>

<script>
import extraApi from "@/extra/extraApi";

export default {
  name: "App",
  data() {
    return {
      invite_code: "",
      showLoading: true,
    };
  },
  components: {
    // Loading,
  },
  mounted() {
    this.parseBusiParam();
    this.loadTask();
  },
  methods: {
    /**
     * 解析 URL 参数中的 invite_code
     */
    parseBusiParam() {
      const params = new URLSearchParams(window.location.search);
      this.invite_code = params.get("t");
    },

    /**
     * 加载业务入口信息并进行跳转
     */
    async loadTask() {
      this.showLoading = true;

      try {
        const res = await extraApi.get(
            `/custOpenAccTask/getBusinessEntry?inviteCode=${this.invite_code}`
        );
        console.log("busiEntry res", res);

        if (res.code === 200) {
          const validPaths = ['/selfAccoutOpen'];
          const targetPath = res.data;
          console.warn("  666  跳转路径", targetPath);
          if (validPaths.some(path => targetPath.startsWith(path))) {
            window.location.href = targetPath;
            console.warn("  666  跳转路径", targetPath);
          } else {
            console.warn("非法跳转路径", targetPath);
            this.$message.error("非法跳转路径");
          }
        }
      } catch (error) {
        console.error("接口请求失败:", error);
        this.$message.error("网络异常，请稍后再试");
      } finally {
        this.showLoading = false;
      }
    },
  },
};
</script>

<style lang="less">

</style>
